module.exports = __webpack_public_path__ + "static/media/resources.fa39b1cb.svg";